import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['display']
  static values = { deadline: String }

  connect () {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect () {
    clearInterval(this.timer)
  }

  tick () {
    const remaining = new Date(this.deadlineValue) - new Date()

    if (remaining <= 0) {
      clearInterval(this.timer)
      this.element.classList.add('hidden')
      return
    }

    const hours = Math.floor(remaining / 3600000)
    const minutes = Math.floor((remaining % 3600000) / 60000)
    const seconds = Math.floor((remaining % 60000) / 1000)
    const pad = (value) => String(value).padStart(2, '0')

    this.displayTarget.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
  }
}
